export default __webpack_public_path__ + "static/media/foxit-member.0f249670.png";